import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";

const CheckOut = () => {
  const { cartItems, clearCart } = useContext(CartContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    zip: "",
    cardNumber: "",
    expiry: "",
    cvv: ""
  });

  const subtotal = cartItems.reduce((total, item) => {
    const product = productData.find(p => p.id === item.id);
    return total + (product ? parseFloat(product.price) * item.quantity : 0);
  }, 0);

  const shipping = 10.00;
  const total = subtotal + shipping;

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Order placed successfully!");
    clearCart();
    navigate("/paysuccess");
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="checkout-page">
      <Header />
      <div className="checkout-container">
        <div className="checkout-left">
          <h2 className="checkout-title">Checkout</h2>
          <form className="checkout-form" onSubmit={handleSubmit}>
            <div className="form-section">
              <h3>Contact Information</h3>
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" name="email" required onChange={handleInputChange} placeholder="Email" />
              </div>
            </div>

            <div className="form-section">
              <h3>Shipping Address</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input type="text" name="firstName" required onChange={handleInputChange} placeholder="First Name" />
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input type="text" name="lastName" required onChange={handleInputChange} placeholder="Last Name" />
                </div>
              </div>
              <div className="form-group">
                <label>Address</label>
                <input type="text" name="address" required onChange={handleInputChange} placeholder="Address" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>City</label>
                  <input type="text" name="city" required onChange={handleInputChange} placeholder="City" />
                </div>
                <div className="form-group">
                  <label>ZIP Code</label>
                  <input type="text" name="zip" required onChange={handleInputChange} placeholder="ZIP Code" />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Payment</h3>
              <div className="form-group">
                <label>Card Number</label>
                <input type="text" name="cardNumber" required onChange={handleInputChange} placeholder="Card Number" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Expiry Date</label>
                  <input type="text" name="expiry" required onChange={handleInputChange} placeholder="MM/YY" />
                </div>
                <div className="form-group">
                  <label>CVV</label>
                  <input type="text" name="cvv" required onChange={handleInputChange} placeholder="CVV" />
                </div>
              </div>
            </div>

            <button type="submit" className="place-order-btn">PLACE ORDER</button>
          </form>
        </div>

        <div className="checkout-right">
          <div className="order-summary">
            <h3>Order Summary</h3>
            <div className="summary-items">
              {cartItems.map((item, index) => {
                const product = productData.find(p => p.id === item.id);
                if (!product) return null;
                return (
                  <div key={index} className="summary-item">
                    <img src={product.image} alt={product.name} />
                    <div className="item-info">
                      <h4>{product.name}</h4>
                      <p>Size: {item.size} x {item.quantity}</p>
                    </div>
                    <div className="item-price">HK${(parseFloat(product.price) * item.quantity).toFixed(2)}</div>
                  </div>
                );
              })}
            </div>
            <div className="summary-totals">
              <div className="total-row">
                <span>Subtotal</span>
                <span>HK${subtotal.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Shipping</span>
                <span>HK${shipping.toFixed(2)}</span>
              </div>
              <div className="total-row grand-total">
                <span>Total</span>
                <span>HK${total.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CheckOut;
